import { createSlice } from "@reduxjs/toolkit";

import {
  getDivisionThunk,
  createDivisionThunk,
  updateDivisionThunk,
  deleteDivisionThunk,
} from "state/action/division";

// Initial state
const initialState = {
  // Get Division inisial state
  getDivision: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Division inisial state
  createDivision: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Division inisial state
  updateDivision: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Division inisial state
  deleteDivision: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  createDivisionInputBody: {
    department: [""],
    directorate: "",
    name: "",
    email: "",
    description: "",
    represented_by: [
      {
        name: "",
        title: "",
        email: "",
        alamat: "",
      },
    ],
    code: "",
  },
  selectedDivision: {
    department: [""],
    directorate: "",
    name: "",
    email: "",
    description: "",
    represented_by: [
      {
        name: "",
        title: "",
        email: "",
        alamat: "",
      },
    ],
    code: "",
  },
  // Division object value
  division_object_value: "",
};

export const divisionSlice = createSlice({
  name: "division",
  initialState,
  reducers: {
    // Reducer untuk field di level atas (name, directorate, description, code)
    setDivisionField: (state, action) => {
      const { field, value } = action.payload;
      state.createDivisionInputBody[field] = value;
    },

    // --- Reducers untuk array 'department' ---
    addDepartment: (state) => {
      state.createDivisionInputBody.department.push("");
    },
    updateDepartment: (state, action) => {
      const { index, value } = action.payload;
      state.createDivisionInputBody.department[index] = value;
    },
    removeDepartment: (state, action) => {
      const index = action.payload;
      state.createDivisionInputBody.department.splice(index, 1);
    },

    // --- Reducers untuk array 'represented_by' ---
    addRepresentative: (state) => {
      state.createDivisionInputBody.represented_by.push({
        name: "",
        title: "",
      });
    },
    updateRepresentative: (state, action) => {
      const { index, field, value } = action.payload;
      state.createDivisionInputBody.represented_by[index][field] = value;
    },
    removeRepresentative: (state, action) => {
      const index = action.payload;
      state.createDivisionInputBody.represented_by.splice(index, 1);
    },

    // Reducer untuk mereset form
    resetDivisionForm: (state) => {
      state.createDivisionInputBody = initialState.createDivisionInputBody;
    },
    setGetDivisionObjectValue: (state, action) => {
      return {
        ...state,
        division_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetDivisionObjectValue: (state, _) => {
      return {
        ...state,
        division_object_value: "",
      };
    },
    setCreateDivisionInputBody: (state, action) => {
      return {
        ...state,
        createDivisionInputBody: action.payload,
      };
    },
    setSelectedDivision: (state, action) => {
      return {
        ...state,
        selectedDivision: action.payload,
      };
    },
    setClearCreateDivisionInputBody: (state, _) => {
      return {
        ...state,
        createDivisionInputBody: {
          department: [""],
          directorate: "",
          name: "",
          email: "",
          description: "",
          represented_by: [
            {
              name: "",
              title: "",
            },
          ],
          code: "",
        },
      };
    },
    setClearCreateDivision: (state, _) => {
      return {
        ...state,
        createDivision: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearGetDivision: (state, _) => {
      return {
        ...state,
        getDivision: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateDivision: (state, _) => {
      return {
        ...state,
        updateDivision: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteDivision: (state, _) => {
      return {
        ...state,
        deleteDivision: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllDivisionState: (state, _) => {
      return {
        ...state,
        // Get Division inisial state
        getDivision: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Division inisial state
        createDivision: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Division inisial state
        updateDivision: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Division inisial state
        deleteDivision: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Division object value
        Division_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Division reducer
      .addCase(getDivisionThunk.pending, (state, _) => {
        return {
          ...state,
          getDivision: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getDivisionThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getDivision: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getDivisionThunk.rejected, (state, action) => {
        return {
          ...state,
          getDivision: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Division reducer
      .addCase(createDivisionThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createDivisionThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createDivisionThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Division reducer
      .addCase(updateDivisionThunk.pending, (state, _) => {
        return {
          ...state,
          updateDivision: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateDivisionThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateDivision: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateDivisionThunk.rejected, (state, action) => {
        return {
          ...state,
          updateDivision: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const divisionAction = {
  ...divisionSlice.actions,
  getDivisionThunk,
  createDivisionThunk,
  updateDivisionThunk,
  deleteDivisionThunk,
};

export function selectDivisionObjectValue(state) {
  return state?.division?.division_object_value;
}

export function selectDivision(state) {
  return state?.division;
}

export default divisionSlice.reducer;
